// extracted by mini-css-extract-plugin
export var cardContainer = "style-module--card-container--80f87";